import requests from "@/common/fetch";
import { Result } from "../common";
import { toCamelCase, toUnderCase } from "@/common/util/transform";
import * as I from "./interface";

/** 站内信标记已读 */
export const markMessageRead = (
  params: I.MarkMessageReadParams
): Result<boolean> => {
  return toCamelCase(
    requests.post("/mmsapi/brandbank/inbox/read/list", toUnderCase(params))
  );
};

/** 查询站内信数量 */
export const queryMessageCount = (
  params: I.QueryMessageCountParams
): Result<I.QueryMessageCountResult> => {
  return toCamelCase(
    requests.post("/mmsapi/brandbank/inbox/query/count", toUnderCase(params))
  );
};

/** 查询站内信 */
export const queryMessageList = (
  params: I.QueryMessageListParams
): Result<I.QueryMessageListResult> => {
  return toCamelCase(
    requests.post("/mmsapi/brandbank/inbox/query/list", toUnderCase(params))
  );
};
